import script from "./DialogSideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./DialogSideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./DialogSideMenu.vue?vue&type=style&index=0&id=892dad06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-892dad06"]])

export default __exports__